import { mockResponse, request, isMockMode } from './client.js';
import { NEWS, UPCOMING_EVENTS } from '../data/news.js';

export function getNews({ category, limit, featured } = {}) {
  if (!isMockMode()) {
    const qs = new URLSearchParams({ ...(category ? { category } : {}), ...(limit ? { limit } : {}) }).toString();
    return request(`/news${qs ? '?' + qs : ''}`);
  }
  return mockResponse(() => {
    let list = NEWS;
    if (category && category !== '全部') list = list.filter(n => n.category === category);
    if (featured) list = list.filter(n => n.featured);
    if (limit) list = list.slice(0, limit);
    return list;
  });
}

export function getFeaturedNews() {
  if (!isMockMode()) return request('/news/featured');
  return mockResponse(() => NEWS.find(n => n.featured) || NEWS[0]);
}

export function getNewsArticle(id) {
  if (!isMockMode()) return request(`/news/${id}`);
  return mockResponse(() => {
    const base = NEWS.find(n => n.id === id) || NEWS[0];
    return {
      ...base,
      content: [
        { type: 'lead', text: base.summary },
        { type: 'p', text: '飛鏢文化在亞洲蓬勃發展，選手與器材的關係日益受到玩家關注。本次發售是品牌與選手合作的里程碑，也是 MICHIDART 持續引進頂級器材的承諾。' },
        { type: 'h2', text: '關於本次商品' },
        { type: 'p', text: '本次商品採用最新工藝打造，每個細節都經過嚴格把關，確保玩家獲得最佳體驗。無論是專業選手或入門新手，都能在這裡找到屬於自己的標。' },
        { type: 'quote', text: '選擇一支適合自己的飛鏢，是找到自己擲法的第一步。— MICHIDART' },
        { type: 'h2', text: '購買資訊' },
        { type: 'p', text: '商品現已於 MICHIDART 官方網站開放選購。GOLD 以上會員享有優先購買資格及專屬折扣。請把握機會，售完即不補貨。' },
      ],
      author: 'MICHIDART 編輯部',
      authorDate: base.date,
      related: NEWS.filter(n => n.id !== id).slice(0, 3),
    };
  });
}

export function getUpcomingEvents() {
  if (!isMockMode()) return request('/events?upcoming=true');
  return mockResponse(UPCOMING_EVENTS);
}
